import { createListSelector } from 'redux/utils'

export const selectComicCollectionData = createListSelector('ComicCollection')
